// import React, { Component } from "react";
// import { Dropdown, DropdownButton } from "react-bootstrap";

// export class AgendaCompose extends Component {
//   onSelect = value => {
//     const { onSelect } = this.props;
//     typeof onSelect === "function" && onSelect(value);
//   };

//   render() {
//     const {
//       props: {
//         id = "",
//         selected = { key: "", title: "Select" },
//         options = [],
//         disabled = false,
//         style,
//         customStyle,
//         isDraft
//       },
//       onSelect
//     } = this;
//     // let cssClassName;
//     // if(isDraft) {
//     //   cssClassName = `custom-drop-down-draft ${
//     //     customStyle ? "custom-style agenda-custom-dropdown" : ""
//     //   }`;
//     // } else {
//     //   cssClassName = `custom-drop-down ${
//     //     customStyle ? "custom-style agenda-custom-dropdown" : ""
//     //   }`
//     // }

//     return (
//       <>
//         <DropdownButton
//           id={id || `dropdown-variants`}
//           title={
//             <span
//               className={` ${style ? style : ""} ${
//                 selected.title !== "Select" && selected.title !== "Compose"
//                   ? "agenda-custom-color"
//                   : ""
//               } `}
//             >
//               {selected.title}
//             </span>
//           }

//           className={`custom-drop-down-draft ${
//             customStyle ? "custom-style agenda-custom-dropdown" : ""
//           }`}
//           disabled={disabled}
//           focusFirstItemOnShow={false}
//         >
//           {console.log("customStyle",customStyle)}
//           {options.map(value => {
//             return (
//               <Dropdown.Item
//                 className={`agenda-custom-color ${
//                   customStyle ? "drop-down-item" : ""
//                 }`}
//                 onClick={() => onSelect(value)}
//                 eventKey={value.key}
//               >
//                 {console.log("value.title", value.title)}
//                 {value.title}
//               </Dropdown.Item>
//             );
//           })}
//         </DropdownButton>
//       </>
//     );
//   }
// }

import React, { Component } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import Dropdownarrow from "../../../assets/new-grey-drop-down-arrow.svg";
export class AgendaCompose extends Component {
  onSelect = value => {
    const { onSelect } = this.props;
    typeof onSelect === "function" && onSelect(value);
  };

  render() {
    const {
      props: {
        id = "",
        selected = { key: "", title: "Select" },
        options = [],
        disabled = false,
        style,
        customStyle
      },
      onSelect
    } = this;
    console.log("stle", customStyle);
    return (
      <>
        <DropdownButton
          id={id || `dropdown-variants`}
          title={
            <span className="composetext1">
              {selected.title}
              <img src={Dropdownarrow} className="arrowbtn1" />
            </span>
          }
          // className="new-custom-dropdown"
          className={`custom-drop-down-draft-1 ${
            customStyle ? "custom-style new-custom-dropdown" : ""
          }`}
          disabled={disabled}
          focusFirstItemOnShow={false}
        >
          {options.map(value => {
            return (
              <Dropdown.Item
                className={`agenda-custom-color ${
                  customStyle ? "drop-down-item" : ""
                }`}
                onClick={() => onSelect(value)}
                eventKey={value.key}
              >
                {value.title}
              </Dropdown.Item>
            );
          })}
        </DropdownButton>
      </>
    );
  }
}
